import { Component, createRef } from 'react';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { Box, Button, TextField, Tooltip, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { DateTime } from 'luxon';
import Loader from '../../../../Components/Loader';
export default class DocFitnessCertific extends Component {
    constructor(props) {
        super(props)
        this.state = {
            patientDetails: {},
            patientId: '',
            doctor_details: {
                city_name: "",
                doctor_name: '',
                regNo: '',
                doctor_id: null
            },
            doctor_content: "",
            date: new Date(),
            companyName: '',
            designation: '',
            effectiveDateOpen: false,
            effectiveDate: null,
            dateOpen: false,
            disableInputs: false,
        }
        this.boxRef = createRef();
    }

    componentDidMount = () => {
        let states = this.state
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        states["patientId"] = appointmentId?.patient_id
        states["appointment_id"] = appointmentId?.appointment_id
        states["doctor_details"]["doctor_name"] = UserData?.doctor_name
        states["doctor_details"]["doctor_id"] = UserData?.doctor_id
        states["doctor_details"]["city_name"] = UserData?.clinic_city
        states["doctor_details"]["regNo"] = (UserData?.module_name === 'JMO') ? localGetItem('regNo') :UserData?.registeration_number
        states["patientDetails"] = appointmentId
        if (this.boxRef.current) {
            this.boxRef.current.innerHTML = this.state.doctor_content;
        }
        this.setState({
            states
        }, () => {
            this.getPatientDetailData()
            this.getFitnessCertifiData()
        })
    }

    getPatientDetailData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientDetails: response?.data?.data ? {...this.state.patientDetails, ...response?.data?.data} : {},
                        }, () => this.handleChangeMainText())
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getFitnessCertifiData = () => {
        try {
            let states = this.state
            this.LoaderFunction(true);
            RestAPIService.getAll(Serviceurls.DOC_FITNESS_CERTFICATE_GET + `?patient_id=${states.patientId}&appointment_id=${states?.appointment_id ? states?.appointment_id : null}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response?.data?.fitness_data?.length > 0 ? response?.data?.fitness_data[response?.data?.fitness_data?.length - 1] : {}
                        this.setState({
                            id: data.id || null,
                            companyName: data.company_name || '',
                            designation: data.designation_name || '',
                            effectiveDate: data.effective_date ? new Date(data.effective_date) : null,
                            date: data.date ? new Date(data.date) : new Date(),
                            doctor_details: {
                                ...states.doctor_details,
                                city_name: data.location || states.doctor_details?.city_name,
                                regNo: data.registration_proof_number || states.doctor_details?.regNo,
                            },
                        }, () => {
                            if (data?.fitness_notes) {
                                this.setState({
                                    doctor_content: data.fitness_notes,
                                    disableInputs: true
                                })
                            } else {
                                this.handleChangeMainText()
                            }
                            this.LoaderFunction(false);
                        });
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.LoaderFunction(false);
                })
        } catch (error) {
            this.errorMessage(error?.message)
            this.LoaderFunction(false);
        }

    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            disableBtn: false
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message,
            disableBtn: false
        })
    }

    LoaderFunction = (value) => {
        this.setState({
            isLoader: value
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    handleFitCertifiSave = () => {
        try {
            let states = this.state
            let data = {
                "id": states.id || null,
                "doctor_id": states.doctor_details?.doctor_id || null,
                "patient_id": states.patientId || null,
                "designation_name": states.designation || '',
                "company_name": states.companyName || '',
                "appointment_id": states.patientDetails?.appointment_id ? states.patientDetails?.appointment_id : this.state.appointment_id ? this.state.appointment_id : null,
                "date": states.date ? DateTime.fromJSDate(states?.date)?.toFormat('yyyy-MM-dd') : '',
                "effective_date": states.effectiveDate ? DateTime.fromJSDate(states?.effectiveDate)?.toFormat('yyyy-MM-dd') : '',
                "fitness_notes": states.doctor_content,
                "patient_name": states.patientDetails?.first_name + states.patientDetails?.last_name || "",
                "doctor_name": states.doctor_details?.doctor_name || '',
                "location": states.doctor_details?.city_name || '',
                "registration_proof_number": states.doctor_details?.regNo || ''
            }
            this.LoaderFunction(true);
            RestAPIService.create(data, Serviceurls.DOC_FITNESS_CERTFICATE_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            disableInputs: true,
                            id: response?.data?.fitness_data?.id || null
                        }, () => {
                            this.getFitnessCertifiData()
                        })
                        this.successMessage(response?.data?.message)
                        this.LoaderFunction(false);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false);
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (e) {
            this.errorMessage(e?.message)
        }
    }

    handleFitCertifiPrint = () => {
        try {
            RestAPIService.getAll(`${Serviceurls.DOC_FITNESS_CERTFICATE_GET}?patient_id=${this.state?.patientId}&appointment_id=${this.state.appointment_id ? this.state.appointment_id : null}&export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ disableBtn: false })
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    handleChange = (e, stateKey) => {
        let states = this.state;
        if (stateKey === "city_name" || stateKey === "regNo") {
            states["doctor_details"][stateKey] = e.target.value
        }
        else {
            states[stateKey] = e.target.value
        }
        this.setState({ states }, () => this.handleChangeMainText())
    }


    renderTextField = (label, stateKey) => {
        let states = this.state;
        let value = (stateKey === "city_name" || stateKey === "regNo") ? states["doctor_details"][stateKey] : states[stateKey]
        const emedTidMap = {
            "companyName": "fitness_certificate_company_name_textfield",
            "designation": "fitness_certificate_designation_textfield",
            "city_name": "fitness_certificate_place_textfield",
            "regNo": "fitness_certificate_registration_no_textfield"
        };
        return (
            <Box margin={'1vw'}>
                <TextField
                    label={label}
                    inputProps={{ maxLength: stateKey === 'diagnosisDetails' ? 250 : (stateKey === "companyName" || stateKey === "city_name") ? 75 : 100 }}
                    emed_tid={stateKey === 'companyName' ? 'doc_fitness_cert_company_name_input' : stateKey === 'designation' ? 'doc_fitness_cert_designation_input' : stateKey === 'city_name' ? 'doc_fitness_cert_place_input' : stateKey === 'regNo' ? 'doc_fitness_cert_reg_no_input' : `doc_fitness_cert_${stateKey}_input`}
                    rows={stateKey === 'diagnosisDetails' && 4}
                    multiline={stateKey === "diagnosisDetails" ? true : false}
                    disabled={stateKey === "regNo" ? true : states.disableInputs}
                    sx={{ width: "100%" }}
                    size="small"
                    autoComplete="off"
                    name={label}
                    value={value ? value : ""}
                    onChange={(e) => { this.handleChange(e, stateKey) }}
                />
            </Box>
        )
    }

    handleDatePickerPopup = (stateKey, open = false) => {
        let states = this.state;
        states[stateKey] = open ? true : false
        this.setState({ states })
    }

    renderDatePicker = (label, statekey, popupState) => {
        let states = this.state;
        const emedTidMap = {
            "date": "fitness_certificate_date_picker",
            "effectiveDate": "fitness_certificate_effective_date_picker"
        };
        return (
            <Box sx={{ margin: '1vw' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        emed_tid={emedTidMap[statekey]}
                        open={states[popupState]}
                        onOpen={() => { this.handleDatePickerPopup(popupState, true) }}
                        onClose={() => { this.handleDatePickerPopup(popupState, false) }}
                        value={states[statekey]}
                        label={label}
                        name={label}
                        disabled={states.disableInputs}
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        onChange={
                            (newDate) => {
                                states[statekey] = newDate?.$d ? newDate?.$d : newDate
                                this.setState({
                                    states
                                }, () => this.handleChangeMainText())
                            }}
                        renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: statekey === "effectiveDate" ? '50%' : '100%' }} size='small' {...params} onClick={() => { this.handleDatePickerPopup(popupState, true) }} emed_tid={`doc_fitness_cert_${statekey}_picker`} />}
                    />
                </LocalizationProvider>
            </Box>
        )
    }

    handleChangeMainText = () => {
        let states = this.state
        const value = `I, Dr. ${states.doctor_details?.doctor_name} do hereby certify that, I have carefully examined ${states?.patientDetails?.title ? states?.patientDetails?.title : 'Dr./Shri/Smt./Ms.'} ${states?.patientDetails?.first_name ? states?.patientDetails?.first_name : '_____'}${states?.patientDetails?.last_name ? ` ${states?.patientDetails?.last_name}` : ""} <b>${states?.designation ? `, ${states?.designation}` : ''}</b> (name & designation of applicant) of the Office of the <b>${states.companyName ? states.companyName : '_____'}</b>, whose signature is given above, and find that he/she has recovered from his/her illness and is now fit to resume effective duties from effective from <b>${states?.effectiveDate ? DateTime.fromJSDate(states?.effectiveDate)?.toFormat('dd-MM-yyyy') : "_____"}</b> (I also certify that before arriving at this decision, I have examined the original fitness certificate and statement of the case (or certified copies thereof) on which leave was granted or extended and have taken these into consideration in arriving at my decision.`
        this.setState({
            doctor_content: value
        }, () => {
            if (this.boxRef.current) {
                this.boxRef.current.innerHTML = value;
            }
        })
    }

    handleValidation = () => {
        let states = this.state
        let msg = null
        if (!states.companyName) {
            msg = "Enter Company Name"
        } else if (!states.effectiveDate) {
            msg = "Select Effective Date"
        } else if (!states.doctor_details?.city_name) {
            msg = "Enter Place"
        } else if (!states.date) {
            msg = "Select Date"
        } else if (!states.doctor_details?.regNo) {
            msg = "Enter Registration No"
        } else {
            msg = null
        }

        if (msg) {
            this.errorMessage(msg)
        } else {
            this.handleFitCertifiSave()
        }
    }

    handleclear = () => {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        this.state["doctor_details"]["city_name"] = UserData?.clinic_city
        this.setState({
            doctor_content: "",
            date: new Date(),
            companyName: '',
            designation: '',
            effectiveDateOpen: false,
            effectiveDate: null,
            dateOpen: false,
            disableInputs: false,
            doctor_details: this.state.doctor_details
        }, () => this.handleChangeMainText())
    }

    render() {
        let states = this.state;
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'73vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                </Box>
                <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'61.5vh'} width={'100%'}>
                    <Box component={'div'} width={'65%'}>
                        <Box border={'1px solid lightgray'} height={"100%"} p={"1.5vw"}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between", height: "10vh" }}>
                                <div style={{ width: '33%' }}></div>
                                <div style={{ fontSize: "1.1vw", fontWeight: "600", textAlign: "center", width: '33%' }}>{`FITNESS CERTIFICATE`}</div>
                                <div style={{ width: '33%', textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', wordBreak: 'break-word' }}>
                                    <div>Place</div>
                                    <div>
                                        {states.doctor_details?.city_name ? (
                                            states.doctor_details.city_name.length > 20 ? (
                                                <Tooltip title={states.doctor_details.city_name} placement="top" arrow>
                                                    <Typography>{`${states.doctor_details.city_name.slice(0, 17)}...`}</Typography>
                                                </Tooltip>
                                            ) : (<Typography>{states.doctor_details.city_name}</Typography>)
                                        ) : ''}
                                    </div>
                                </div>
                            </div>
                            <div>Signature of Applicant .........................</div>
                            <br />
                            <Box
                                ref={this.boxRef}
                                contentEditable
                                suppressContentEditableWarning={true}
                                sx={{
                                    width: "100%",
                                    overflowY: "auto",
                                    fontSize: "1rem",           // 16px
                                    lineHeight: "1.4375em",     // ~23px
                                    height: `${5 * 23}px`,      // rows * line-height ≈ 115px
                                    whiteSpace: "pre-wrap",
                                    outline: "none",
                                    fontWeight: 400,
                                }}
                                spellCheck="false"
                                onInput={() => {
                                    if (this.boxRef.current) {
                                        this.setState({ doctor_content: this.boxRef.current.innerHTML });
                                    }
                                }}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    const text = e.clipboardData.getData("text/plain");

                                    const sel = window.getSelection();
                                    if (!sel.rangeCount) return;
                                    const range = sel.getRangeAt(0);
                                    range.deleteContents();
                                    range.insertNode(document.createTextNode(text));

                                    // Move caret to end of inserted text
                                    range.collapse(false);
                                    sel.removeAllRanges();
                                    sel.addRange(range);

                                    if (this.boxRef.current) {
                                        this.setState({ doctor_content: this.boxRef.current.innerHTML });
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stop default <div>/<br>

                                        const sel = window.getSelection();
                                        if (!sel.rangeCount) return;

                                        const range = sel.getRangeAt(0);

                                        // Insert newline at caret
                                        const textNode = document.createTextNode("\n");
                                        range.insertNode(textNode);

                                        // Move cursor after the newline
                                        range.setStartAfter(textNode);
                                        range.setEndAfter(textNode);

                                        sel.removeAllRanges();
                                        sel.addRange(range);

                                        // Ensure caret stays visible
                                        setTimeout(() => {
                                            if (this.boxRef.current) {
                                                this.boxRef.current.scrollTop = this.boxRef.current.scrollHeight;
                                            }
                                        }, 0);
                                    }
                                }}
                            />
                            <div style={{ marginTop: "5vh", display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <div>Signature of Medical Officer /</div>
                                <div>Doctor along with official seal</div>
                                <br />
                                <div>{`Registration No. ${states.doctor_details?.regNo ? states.doctor_details?.regNo : ''}`}</div>
                            </div>
                            <div>Date: {`${states?.date ? DateTime.fromJSDate(states?.date).toFormat('dd-MM-yyyy') : ''}`}</div>
                        </Box>
                    </Box>
                    <Box component="div" width={'35%'} border="1px solid lightgray" height={"61.5vh"}>
                        <Box height="5.15vh" display="flex" pl="0.5vw" alignItems="center">
                            <Typography fontWeight={600}>Fitness Certificate</Typography>
                        </Box>
                        <Box sx={{ height: '50vh', overflow: 'auto', backgroundColor: Colors.white }}>
                            {this.renderTextField("Company/Office Name *", "companyName", true)}
                            {this.renderTextField("Designation", "designation")}
                            <hr />
                            {this.renderTextField("Place *", "city_name")}
                            <Box display="flex">
                                {this.renderDatePicker("Date *", "date", "dateOpen")}
                                {this.renderTextField("Registration No *", "regNo")}
                            </Box>
                            {this.renderDatePicker("Effective Date *", "effectiveDate", "effectiveDateOpen")}
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" height="6.18vh">
                            {this.state.disableInputs ? <Button
                                variant='outlined'
                                emed_tid='fitness_certifi_reset'
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                                onClick={() => { this.handleclear() }}
                            >{"Reset"}</Button> : null}
                            <Button
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                                variant="outlined"
                                emed_tid='fitness_certifi_save'
                                disabled={this.state.disableBtn|| getCachevalue('DoctorUserChanged') === 'true'}
                                onClick={() => this.setState({ disableBtn: true }, () => this.handleValidation())}
                            >
                                Save
                            </Button>
                            <Button
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                                variant="contained"
                                emed_tid='fitness_certifi_print'
                                disabled={!this.state.id || this.state.disableBtn}
                                onClick={() => this.setState({ disableBtn: true }, () => this.handleFitCertifiPrint())}
                            >
                                Print
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <div>
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}

                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                </div>
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}